/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityCreationImage } from './entityCreationImage';
import { PropositionTagv5 } from './propositionTagv5';


export interface IdeaCreation { 
    Description: string;
    Visibility?: string | null;
    Images?: Array<EntityCreationImage> | null;
    Tags?: Array<PropositionTagv5> | null;
    Video?: string | null;
    MarketSectors?: Array<number> | null;
    AiGenerated?: boolean;
    Title?: string | null;
}

